/**
 * Picker Color Constants
 * Unified color palette used across the application for color pickers
 *
 * Used in:
 * - ColourPicker component
 * - Activities, Labels, Templates, and any color selection
 *
 * System label colors (Chore, Social, Purchase) are included in this palette
 */

export const PICKER_COLORS = [
  { name: "White", value: "#ffffff" },
  { name: "Orange", value: "#c26229" }, // Default label color, Chore
  { name: "Red", value: "#f44336" },
  { name: "Pink", value: "#e91e63" },
  { name: "Purple", value: "#9c27b0" }, // Purchase
  { name: "Deep Purple", value: "#673ab7" },
  { name: "Indigo", value: "#3f51b5" },
  { name: "Blue", value: "#2196f3" },
  { name: "Cyan", value: "#00bcd4" }, // Social
  { name: "Teal", value: "#009688" },
  { name: "Green", value: "#4caf50" },
  { name: "Light Green", value: "#619c43" },
  { name: "Yellow", value: "#ffa600" },
  { name: "Brown", value: "#795548" },
  { name: "Gray", value: "#444444" },
  { name: "Black", value: "#000000" },
];

/**
 * System label colors applied to default labels (Chore, Social, Purchase)
 * Must match backend SYSTEM_LABEL_COLORS in infrastructure/lib/constants/labelColors.ts
 */
export const SYSTEM_LABEL_COLORS = {
  1: "#c26229", // Chore - Orange
  2: "#00bcd4", // Social - Cyan
  3: "#9c27b0", // Purchase - Purple
};

/**
 * Default label color used when no color is specified
 */
export const DEFAULT_LABEL_COLOR = "#c26229";

/**
 * Default activity color used when no color is specified
 */
export const DEFAULT_ACTIVITY_COLOR = "#ffffff";

/**
 * Default template color
 */
export const DEFAULT_TEMPLATE_COLOR = "#6366f1";
